import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtronumerico',
    standalone: false,
})
export class FiltronumericoPipe implements PipeTransform {

  transform(items: any[], field: string, value: number): any {
    if (!items) return [];
    if (!value) return items;
    return items.filter(it => it[field] == value);
  }

}
